import { Notification } from 'element-ui'
export function notifyInof(msg) {}

export function notifySuccess(msg) {}

export function notifyError(msg) {}

export function notifyWarning(msg) {}
